// Advertising Agent — Ad Agency trigger action types + creators

export const GENERATE_AD_CREATIVE_REQUEST  = "GENERATE_AD_CREATIVE_REQUEST";
export const GENERATE_AD_CREATIVE_SUCCESS  = "GENERATE_AD_CREATIVE_SUCCESS";
export const GENERATE_AD_CREATIVE_FAILURE  = "GENERATE_AD_CREATIVE_FAILURE";

export const PUBLISH_AD_CREATIVE_REQUEST   = "PUBLISH_AD_CREATIVE_REQUEST";
export const PUBLISH_AD_CREATIVE_SUCCESS   = "PUBLISH_AD_CREATIVE_SUCCESS";
export const PUBLISH_AD_CREATIVE_FAILURE   = "PUBLISH_AD_CREATIVE_FAILURE";

export const TRIGGER_ART_DEPT_REQUEST      = "TRIGGER_ART_DEPT_REQUEST";
export const TRIGGER_ART_DEPT_SUCCESS      = "TRIGGER_ART_DEPT_SUCCESS";
export const TRIGGER_ART_DEPT_FAILURE      = "TRIGGER_ART_DEPT_FAILURE";

export const TRIGGER_AD_VIDEO_REQUEST      = "TRIGGER_AD_VIDEO_REQUEST";
export const TRIGGER_AD_VIDEO_SUCCESS      = "TRIGGER_AD_VIDEO_SUCCESS";
export const TRIGGER_AD_VIDEO_FAILURE      = "TRIGGER_AD_VIDEO_FAILURE";

export const TRIGGER_GOOGLE_ADS_CAMPAIGN_REQUEST = "TRIGGER_GOOGLE_ADS_CAMPAIGN_REQUEST";
export const TRIGGER_GOOGLE_ADS_CAMPAIGN_SUCCESS = "TRIGGER_GOOGLE_ADS_CAMPAIGN_SUCCESS";
export const TRIGGER_GOOGLE_ADS_CAMPAIGN_FAILURE = "TRIGGER_GOOGLE_ADS_CAMPAIGN_FAILURE";

export const PUBLISH_GOOGLE_AD_REQUEST     = "PUBLISH_GOOGLE_AD_REQUEST";
export const PUBLISH_GOOGLE_AD_SUCCESS     = "PUBLISH_GOOGLE_AD_SUCCESS";
export const PUBLISH_GOOGLE_AD_FAILURE     = "PUBLISH_GOOGLE_AD_FAILURE";

export const GET_GOOGLE_AD_STATUS_REQUEST  = "GET_GOOGLE_AD_STATUS_REQUEST";
export const GET_GOOGLE_AD_STATUS_SUCCESS  = "GET_GOOGLE_AD_STATUS_SUCCESS";
export const GET_GOOGLE_AD_STATUS_FAILURE  = "GET_GOOGLE_AD_STATUS_FAILURE";

export const GOOGLE_ADS_OAUTH_CALLBACK_REQUEST = "GOOGLE_ADS_OAUTH_CALLBACK_REQUEST";
export const GOOGLE_ADS_OAUTH_CALLBACK_SUCCESS = "GOOGLE_ADS_OAUTH_CALLBACK_SUCCESS";
export const GOOGLE_ADS_OAUTH_CALLBACK_FAILURE = "GOOGLE_ADS_OAUTH_CALLBACK_FAILURE";

// Action creators

export const generateAdCreativeRequest = (payload) => ({ type: GENERATE_AD_CREATIVE_REQUEST, payload });
export const generateAdCreativeSuccess = (result)  => ({ type: GENERATE_AD_CREATIVE_SUCCESS, payload: result });
export const generateAdCreativeFailure = (error)   => ({ type: GENERATE_AD_CREATIVE_FAILURE, error });

export const publishAdCreativeRequest  = (payload) => ({ type: PUBLISH_AD_CREATIVE_REQUEST, payload });
export const publishAdCreativeSuccess  = (result)  => ({ type: PUBLISH_AD_CREATIVE_SUCCESS, payload: result });
export const publishAdCreativeFailure  = (error)   => ({ type: PUBLISH_AD_CREATIVE_FAILURE, error });

export const triggerArtDeptRequest     = (payload) => ({ type: TRIGGER_ART_DEPT_REQUEST, payload });
export const triggerArtDeptSuccess     = (result)  => ({ type: TRIGGER_ART_DEPT_SUCCESS, payload: result });
export const triggerArtDeptFailure     = (error)   => ({ type: TRIGGER_ART_DEPT_FAILURE, error });

export const triggerAdVideoRequest     = (payload) => ({ type: TRIGGER_AD_VIDEO_REQUEST, payload });
export const triggerAdVideoSuccess     = (result)  => ({ type: TRIGGER_AD_VIDEO_SUCCESS, payload: result });
export const triggerAdVideoFailure     = (error)   => ({ type: TRIGGER_AD_VIDEO_FAILURE, error });

export const triggerGoogleAdsCampaignRequest = (payload) => ({ type: TRIGGER_GOOGLE_ADS_CAMPAIGN_REQUEST, payload });
export const triggerGoogleAdsCampaignSuccess = (result)  => ({ type: TRIGGER_GOOGLE_ADS_CAMPAIGN_SUCCESS, payload: result });
export const triggerGoogleAdsCampaignFailure = (error)   => ({ type: TRIGGER_GOOGLE_ADS_CAMPAIGN_FAILURE, error });

export const publishGoogleAdRequest    = (payload) => ({ type: PUBLISH_GOOGLE_AD_REQUEST, payload });
export const publishGoogleAdSuccess    = (result)  => ({ type: PUBLISH_GOOGLE_AD_SUCCESS, payload: result });
export const publishGoogleAdFailure    = (error)   => ({ type: PUBLISH_GOOGLE_AD_FAILURE, error });

export const getGoogleAdStatusRequest  = (payload) => ({ type: GET_GOOGLE_AD_STATUS_REQUEST, payload });
export const getGoogleAdStatusSuccess  = (result)  => ({ type: GET_GOOGLE_AD_STATUS_SUCCESS, payload: result });
export const getGoogleAdStatusFailure  = (error)   => ({ type: GET_GOOGLE_AD_STATUS_FAILURE, error });

export const googleAdsOAuthCallbackRequest = (payload) => ({ type: GOOGLE_ADS_OAUTH_CALLBACK_REQUEST, payload });
export const googleAdsOAuthCallbackSuccess = (result)  => ({ type: GOOGLE_ADS_OAUTH_CALLBACK_SUCCESS, payload: result });
export const googleAdsOAuthCallbackFailure = (error)   => ({ type: GOOGLE_ADS_OAUTH_CALLBACK_FAILURE, error });
